import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useActiveStoreCatalog } from "../../store/selectors/menu";
import MenuIcon from "@mui/icons-material/Menu";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import { useRef } from "react";
import { IMG_URL } from "../../utils/constant";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Drawer from "@mui/material/Drawer";
import {
  BUTTON_COLOR,
  TEXT_COLOR,
  BACKGROUND_COLOR,
} from "../../utils/constant";
import List from "@mui/material/List";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import veg from "../../assets/img/veg.png";
import nonveg from "../../assets/img/nonveg.png";
import {
  set_customer,
  set_last_order,
  set_order_type,
  set_filters,
} from "../../store/actions/action";

import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { Grid, IconButton, Typography, makeStyles } from "@material-ui/core";
import TuneIcon from "@mui/icons-material/Tune";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import { get_banner_detial } from "../../utils/order_helper";
import search from "../../assets/img/searchBg.png";
import FilterPopup from "../items/FilterPopup";
import ItemCategory from "./ItemCategory";
import Navbar from "../../components/Navbar";
import ItemMenu from "./items";
import { Divider } from "@mui/material";

const useStyles = makeStyles({
  searchInput: {
    background: "#eeeeee",
    borderRadius: "0.5rem",
    width: "95%",
    margin: "5px auto",
    display: "flex",
  },
});

const MenuItem = function (props) {
  const { cartProps, reducer, appliedfilters } = props;
  const { addedItems } = cartProps;
  const { customer } = reducer;
  const storeInfo = props.sessionReducer?.store_details || {};
  const storeInfoConfig = props.sessionReducer?.store_config || {};

  let primaryColor = storeInfoConfig?.general_config?.primary_color || storeInfo?.primary_color || BUTTON_COLOR;
  let secondaryColor = storeInfoConfig?.general_config?.secondary_color;

  // The page background is `primaryColor`; pick a text color that contrasts with
  // it so category names and items stay readable on both dark- and light-themed
  // stores (hard-coding white made everything invisible on light backgrounds).
  const getContrastText = (bg) => {
    if (!bg) return "#ffffff";
    let color = String(bg).trim().toLowerCase();
    const named = { white: "#ffffff", black: "#000000" };
    if (named[color]) color = named[color];
    if (color[0] !== "#") return "#ffffff"; // unknown/named color → assume dark bg
    let hex = color.slice(1);
    if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
    if (hex.length !== 6) return "#ffffff";
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance > 0.6 ? "#111111" : "#ffffff";
  };
  const textColor = getContrastText(primaryColor || BACKGROUND_COLOR);

  const navigate = useNavigate();
  const isDesktop = useMediaQuery("(min-width: 900px)");

  useEffect(() => {
    if (isDesktop) {
      navigate("/menu");
    }
  }, [isDesktop, navigate]);

  const [openSidebar, setOpenSidebar] = React.useState(false);
  const [banner, setBanner] = useState([]);
  const [isReload, setIsReload] = useState(true);
  const [open, setOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [itemList, setItemList] = useState([]);
  const [dietaryArray, setDietaryArray] = useState("");
  const [dietaryFilter, setDietaryFilter] = useState([]);
  const [openedIndex, setOpenedIndex] = useState(null);
  const [allitem, setAllitem] = useState([]);
  const [labelList, setLabelList] = useState([]);
  const [allCategoryList, setAllCategoryList] = useState([]);
  const [selectedMasterCategory, setSelectedMasterCategory] =
    useState("All_Item");
  const [selectedSubCategory, setSelectedSubCategory] = useState();
  const [itemVerriantList, setItemVerriantList] = useState([]);
  const [selectedfilter, setSelectedfilter] = useState("");

  const classes = useStyles();

  let storeCurrency = storeInfo?.store_currency;
  const [currency, setCurrency] = useState(() => {
    switch (storeCurrency) {
      case "INR":
        return "₹";
      case "USD":
        return "$";
      case "CAD":
        return "$";
      case "OMR":
        return "OMR ";
      case "AED":
        return "AED ";
      default:
        return "$";
    }
  });

  useEffect(() => {
    switch (storeCurrency) {
      case "INR": setCurrency("₹"); break;
      case "USD":
      case "CAD": setCurrency("$"); break;
      case "OMR": setCurrency("OMR "); break;
      case "AED": setCurrency("AED "); break;
      default: setCurrency("$");
    }
  }, [storeCurrency]);

  const activeStoreCatalog = useActiveStoreCatalog();
  const { items: catalogItems, categories: catalogCategories, labels: catalogLabels, item_variants: catalogItemVariants } = activeStoreCatalog;
  const paragraphRefs = useRef([]);
  const categoryRefs = useRef({});
  const scrollContainerRef = useRef(null);
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    // Filter items based on search query
    let filteredData = allitem;
    if (searchQuery && searchQuery.trim()) {
      const tokens = searchQuery.trim().split(/\s+/).filter(Boolean);
      const tokenRegexes = tokens.map((tok) => {
        const base = tok.replace(/(?:s|es)$/i, "");
        const escBase = base.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const escTok = tok.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        return new RegExp(`\\b(?:${escTok}|${escBase}(?:s|es)?)`, "i");
      });

      filteredData = filteredData.filter((data) => {
        const catObj = (allCategoryList || catalogCategories || []).find((c) => String(c.category_id) === String(data.category_id));
        const catName = data.category_name || catObj?.category_name || "";
        const itemTags = Array.isArray(data.tag)
          ? data.tag
          : (Array.isArray(data.tags) ? data.tags : (data.tags ? String(data.tags).split(",") : []));

        const itemSearchable = [
          data.item_name,
          data.item_description,
          data.description,
          catName,
          data.dietary,
          ...itemTags,
        ]
          .filter(Boolean)
          .join(" ");

        return tokenRegexes.every((rgx) => rgx.test(itemSearchable));
      });
    }
    setSearchResults(filteredData); // Update search results
  }, [searchQuery, allitem, allCategoryList, catalogCategories]);

  const handleCategoryClick = (obj, type, index) => {
    filterItems(obj, type);
    props.set_filters({ ...appliedfilters, category: { type, obj } });

    // Toggle the opened index, closing others
    const isAccordionOpen = openedIndex === index;
    setOpenedIndex(isAccordionOpen ? null : index);

    // Scroll the clicked category to the center after the accordion expands
    setTimeout(() => {
      const categoryElement = categoryRefs.current[obj.category_id];
      const scrollContainer = scrollContainerRef.current;

      if (categoryElement && scrollContainer) {
        const categoryElementTop = categoryElement.offsetTop;
        const categoryElementHeight = categoryElement.offsetHeight;
        const containerHeight = scrollContainer.clientHeight;

        // Calculate the position to scroll the category to the center
        let scrollToPosition =
          categoryElementTop - containerHeight / 2 + categoryElementHeight / 2;
        scrollToPosition = categoryElementTop - 400;
        // Perform smooth scrolling to the calculated position
        scrollContainer.scroll({
          top: scrollToPosition,
          behavior: "smooth",
        });
      }
    }, 400); // Wait 200ms for accordion to expand
  };

  // let selectCategory = selectedMasterCategory ? selectedMasterCategory : "All_Item";

  let categorySeq = selectedSubCategory?.sort((a, b) => {
    const catA = a.cat_sequence_no || 0;
    const catB = b.cat_sequence_no || 0;
    return catA - catB;
  });

  const getCategoryStyle = (index) => {
    return {};
  };

  const selectedStyle = (index) => {
    return {
      fontWeight: 600,
      color:  textColor,
      fontFamily: "Nunito",
      fontSize: "20px",
      lineHeight: "13px",
      textAlign: "left",
      textTransform: "capitalize",
    };
  };

  const scrollToItem = (index) => {
    paragraphRefs.current[index]?.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "nearest",
    });
  };

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };
  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  const onloadData = async () => {
    try {
      const storeBanner = await get_banner_detial();
      setBanner(storeBanner);
      setIsReload(false);
    } catch (error) {
      console.error("Error while loading data:", error);
    }
  };

  useEffect(() => {
    if (isReload) {
      onloadData();
    }
  }, [isReload]);

  useEffect(() => {
    const onloadData1 = async () => {
      const catData = catalogCategories || [];
      const itemData = catalogItems || [];
      const label = catalogLabels || [];
      const allItemVerriant = catalogItemVariants || [];
      setAllCategoryList(catData);
      setAllitem(itemData);
      setLabelList(label);
      setItemVerriantList(allItemVerriant);

      if (!itemData?.length) {
        setIsReload(true);
      }

      const uniqueDietarySet = new Set();
      if (itemData?.length) {
        itemData.forEach((item) => {
          if (item.dietary) {
            uniqueDietarySet.add(item.dietary.toLowerCase());
          }
        });
      }
      const uniqueDietary = Array.from(uniqueDietarySet);
      setDietaryArray(uniqueDietary);
    };

    onloadData1();
  }, [catalogItems, catalogCategories, catalogLabels, catalogItemVariants]);

  useEffect(() => {
    let filteredData = allitem;
    if (searchQuery && searchQuery.trim()) {
      const tokens = searchQuery.trim().split(/\s+/).filter(Boolean);
      const tokenRegexes = tokens.map((tok) => {
        const base = tok.replace(/(?:s|es)$/i, "");
        const escBase = base.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        const escTok = tok.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        return new RegExp(`\\b(?:${escTok}|${escBase}(?:s|es)?)`, "i");
      });

      filteredData = filteredData.filter((data) => {
        const catObj = (allCategoryList || catalogCategories || []).find((c) => String(c.category_id) === String(data.category_id));
        const catName = data.category_name || catObj?.category_name || "";
        const itemTags = Array.isArray(data.tag)
          ? data.tag
          : (Array.isArray(data.tags) ? data.tags : (data.tags ? String(data.tags).split(",") : []));

        const itemSearchable = [
          data.item_name,
          data.item_description,
          data.description,
          catName,
          data.dietary,
          ...itemTags,
        ]
          .filter(Boolean)
          .join(" ");

        return tokenRegexes.every((rgx) => rgx.test(itemSearchable));
      });
    }
    setItemList(filteredData);
  }, [searchQuery, allitem, dietaryFilter, allCategoryList, catalogCategories]);

  useEffect(() => {
    const { obj, type } = appliedfilters?.category || {};
    filterItems(obj, type);
  }, [allitem, appliedfilters, dietaryFilter]);

  const filterItems = (obj, type) => {
    let filered = catalogItems || [];
    let name = "";
    let id = "";
    if (obj?.master_category_id === "All_Item") {
      name = "All Item";
      id = "All_Item";
      setSelectedMasterCategory(id);
    } else {
      if (type === "MasterCategory") {
        filered = filered.filter(
          (e) => e?.master_category_id === obj.master_category_id
        );
        name = obj.master_category_name;
        id = obj.master_category_id;
        setSelectedMasterCategory(id);
      } else if (type === "category") {
        filered = filered.filter((e) => e?.category_id === obj.category_id);
        name = obj.category_name;
        id = obj.category_id;
      } else if (type === "label") {
        filered = filered.filter((e) => e?.tag.includes(obj.name));
        name = obj.name;
        id = obj.name;
      }
    }

    if (dietaryFilter?.length > 0) {
      filered = filered.filter((item) =>
        dietaryFilter.includes(item.dietary?.toLowerCase())
      );
    }

    if (selectedfilter === "low") {
      filered.sort((a, b) => {
        const priceA = a.item_variant[0]?.plu || 0;
        const priceB = b.item_variant[0]?.plu || 0;
        return priceA - priceB;
      });
    } else if (selectedfilter === "high") {
      filered.sort((a, b) => {
        const priceA = a.item_variant[0]?.plu || 0;
        const priceB = b.item_variant[0]?.plu || 0;
        return priceB - priceA;
      });
    }

    setItemList([...filered]);
  };

  // let filterPriceItems = itemList?.filter((e) => e?.item_variant[0]?.plu !== 0);

  let filterPriceItems = itemList?.filter((e) => parseFloat(e?.item_variant?.[0]?.plu) >= 0);

  const sortBySeq = (itemList1) => {
    return itemList1.sort((a, b) => {
      const seq1 = a.sequence_no || 0;
      const seq2 = b.sequence_no || 0;
      return seq1 - seq2;
    });
  };

  sortBySeq(filterPriceItems);

  const sortByVarient = (itemList2) => {
    return itemList2.sort((a, b) => {
      const seq1 = a.item_variant?.length || 0;
      const seq2 = b.item_variant?.length || 0;
      return seq2 - seq1;
    });
  };

  sortByVarient(filterPriceItems);

  return (
    <div
      style={{
        ...(storeInfo.store_id === "368" || storeInfo.store_id === "366"
          ? { width: "40%", minHeight: "100vh" }
          : { width: "100%", minHeight: "100vh" }),
        background: primaryColor || BACKGROUND_COLOR,
      }}
    >
      <Navbar cart item />
      <Grid container xs={12} sm={12} md={12} lg={12} style={{ padding: "10px 0" }}>
        <Grid xs={2} sm={2} md={2} lg={2} />
        <Grid
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          xs={8}
          sm={8}
          md={8}
          lg={8}
        >
          <img
            alt="Logo"
            style={{
              padding: "0.7rem",
              ...(storeInfo.store_id === "368" || "366"
                ? { width: "30%" }
                : { width: "80%" }),
            }}
            src={storeInfo.store_display_logo}
          />
        </Grid>
        <Grid xs={2} sm={2} md={2} lg={2}>
          <AccountCircleOutlinedIcon
            style={{
              zIndex: "1",
              position: "relative",
              color:  textColor,
              width: "50%",
              height: "100%",
            }}
            onClick={handleSidebarOpen}
          />
        </Grid>
      </Grid>

      {/* banner */}
      <Grid container style={{ marginTop: "-1rem", padding: "1rem" }}>
        <Drawer anchor="right" open={openSidebar} onClose={handleSidebarClose}>
          <Box
            sx={{ width: 250 }}
            role="presentation"
            onClick={handleSidebarClose}
            onKeyDown={handleSidebarClose}
          >
            <Grid
              container
              justifyContent="center"
              xs={12}
              sm={12}
              md={12}
              lg={12}
              style={{ padding: "1rem" }}
            >
              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                lg={3}
                style={{
                  display: "flex",
                  alignContent: "center",
                  flexWrap: "wrap",
                }}
              >
                <svg
                  width="45"
                  height="45"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.6077 19.1937C19.2111 18.4166 18.6877 17.6875 18.0374 17.0373C14.7031 13.7029 9.29705 13.7029 5.96272 17.0373C5.31247 17.6875 4.78903 18.4166 4.3924 19.1937M1 12C1 5.92487 5.92487 0.999999 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 0.999999 18.0751 1 12ZM16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10Z"
                    stroke="#111111"
                    stroke-width="2"
                  />
                </svg>
              </Grid>

              <Grid
                item
                xs={9}
                sm={9}
                md={9}
                lg={9}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography>
                  {customer !== null && customer?.cust_first_name
                    ? customer.cust_first_name
                    : "Guest"}
                </Typography>
                {/* <Typography>My Account</Typography> */}
              </Grid>
            </Grid>
            <Divider
              style={{
                width: "100%",
                backgroundColor:  textColor,
                height: "0.3rem",
              }}
            ></Divider>
            <List>
              {!(props.sessionReducer?.is_fsr === true) && (
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={() => {
                      navigate("/");
                    }}
                  >
                    <ListItemText
                      primary={"Home"}
                      className={classes.menu_text}
                    />
                  </ListItemButton>
                </ListItem>
              )}
              <ListItem disablePadding></ListItem>
            </List>

            <Divider style={{ height: "0.1rem" }}></Divider>
            <Grid
              style={{
                position: "absolute",
                bottom: "10px",
                minWidth: "100%",
              }}
            >
              <List>
                <ListItem disablePadding>
                  <ListItemButton
                    style={{ padding: "0rem", paddingLeft: "0.5rem" }}
                    onClick={() => {
                      navigate("/contactus");
                    }}
                  >
                    <ListItemText
                      style={{ margin: "0px", marginLeft: "1rem" }}
                      primary={"Contact Us "}
                      className={classes.menu_text}
                    />
                  </ListItemButton>
                </ListItem>
              </List>
            </Grid>

            <Divider />
          </Box>
        </Drawer>
        <Grid item xs={12}>
          <div style={{ maxWidth: "100%", margin: "auto", maxHeight: "60%" }}>
            <Carousel
              showArrows={false}
              showThumbs={false}
              showStatus={false}
              autoPlay={true}
              infiniteLoop={true}
              interval={2000}
              stopOnHover={false}
              showIndicators={false}
            >
              {banner?.map((e) => (
                <>
                  <img
                    alt="Banner"
                    style={{
                      minWidth: "100%",
                      borderRadius: "18px",
                    }}
                    src={IMG_URL + e.store_id + "/" + e.banner_link}
                  />
                </>
              ))}
            </Carousel>
          </div>
        </Grid>
      </Grid>
      {/* search box and fiter */}
      <Grid
        style={{
          display: "flex",
          margin: "0rem 1rem",
        }}
      >
        <Grid
          style={{
            // background: "linear-gradient(151.17deg, rgba(87, 87, 87, 0.1) 7.41%, rgba(87, 87, 87, 0.4) 81.62%)",
            backdropFilter: "blur(40px)",
            boxShadow: "0px 4px 4px 0px #00000040",
            borderRadius: "10px",
            minWidth: "90%",
            display: "flex",
            padding: "0.5rem 0rem",
          }}
        >
          <IconButton aria-label="menu">
            <SearchIcon style={{ color:  textColor }} />
          </IconButton>
          <InputBase
            sx={{ flex: 1, color:  textColor }}
            style={{ fontFamily: "Mulish", padding: "0rem 12px" }}
            // placeholder="Search"
            inputProps={{ "aria-label": "search" }}
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />

          {searchQuery && (
            <IconButton
              type="button"
              sx={{ p: "0px", color:  textColor }}
              aria-label="clear"
              onClick={() => setSearchQuery("")}
            >
              <CloseIcon style={{ color:  textColor }} />
            </IconButton>
          )}
        </Grid>
        <IconButton
          type="button"
          sx={{ p: "0px" }}
          aria-label="search"
          onClick={() => setOpen(true) + setOpenedIndex(null)}
        >
          <TuneIcon
            style={{
              color:  textColor,
              height: "30%",
            }}
          />
        </IconButton>
      </Grid>

      <ItemCategory
        {...props}
        {...{
          allitem,
          labelList,
          // categoryList,
          setOpenedIndex,
          setAllCategoryList,
          allCategoryList,
          setSelectedSubCategory,
          selectedMasterCategory,
          filterItems,
          setOpen,
          storeInfo,
        }}
      />
      <FilterPopup
        {...props}
        {...{
          dietaryArray,
          isReload,
          itemList,
          setDietaryFilter,
          setItemList,
          open,
          setSelectedfilter,
          selectedfilter,
          setOpen,
          storeInfo,
        }}
      />
      <div>
        {searchQuery && searchResults.length > 0 ? ( // Check if there is a search query and results
          <div
            style={{
              maxHeight: "400px", // Adjust height as needed
              overflowY: "auto", // Enable vertical scrolling
              overflowX: "hidden", // Prevent horizontal scrolling
              padding: "1rem", // Optional: Padding for aesthetics
            }}
          >
            {searchResults.map((item) => (
              <div
                key={item.id}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Grid
                  container
                  style={{
                    padding: "1rem",
                    minHeight: "60px",
                    textAlign: "left",
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "center",
                    color:  textColor,
                  }}
                >
                  <Grid
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      // alignItems:"center"
                    }}
                    xs={9}
                  >
                    {item.dietary && item?.dietary !== "" ? (
                      <img
                        src={
                          item?.dietary === "veg"
                            ? veg
                            : item?.dietary === "non-veg"
                            ? nonveg
                            : null
                        }
                        alt="img"
                        style={{
                          width: "15px",
                          height: "15px",
                          marginTop: "0.3rem",
                          marginRight: "0.5rem",
                          marginLeft: "-1.1rem",
                        }}
                      />
                    ) : (
                      ""
                    )}
                    <Typography
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        marginLeft: "0.3rem",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "18px",
                          fontWeight: "400",
                          textTransform: "capitalize",
                          fontFamily: "Nunito",
                        }}
                      >
                        {item.item_name}
                      </span>
                      <span
                        style={{
                          color: "gray",
                          fontSize: "14px",
                        }}
                      >
                        {item?.description !== "null" ? item?.description : ""}
                      </span>
                    </Typography>
                  </Grid>
                  <Grid
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                    item
                    xs={3}
                  >
                    <Typography>
                      <span>{currency} {item.item_variant[0]?.plu}</span>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <Typography>
                      {/* If you have a variant value, uncomment the line below */}
                      {/* <span>{variant?.plu}</span> */}
                    </Typography>
                  </Grid>
                </Grid>
                <Divider
                  style={{
                    width: "95%",
                    borderBottom: "1px dotted gray",
                    height: "0px",
                  }}
                />
              </div>
            ))}
          </div>
        ) : (
          <div>
            {isReload ? (
              <Typography>Loading Menu..</Typography>
            ) : (
              <div
                ref={scrollContainerRef}
                style={{
                  overflowY: "auto",
                  scrollbarWidth: "none",
                  minWidth: "90vw",
                  margin: "0rem 1rem",
                  height: "45vh",
                }}
              >
                {categorySeq?.map((obj, index) => (
                  <div
                    key={obj.category_id}
                    ref={(el) => (categoryRefs.current[obj.category_id] = el)}
                  >
                    <Accordion
                      expanded={openedIndex === index}
                      style={{
                        marginBottom: "10px",
                        boxShadow: "none",
                        backgroundColor: "transparent",
                      }}
                    >
                      <AccordionSummary
                        expandIcon={
                          <ExpandMoreIcon
                            style={{
                              color:  textColor,
                              fontSize: "27px",
                            }}
                          />
                        }
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}-header`}
                        onClick={() =>
                          handleCategoryClick(obj, "category", index)
                        }
                        style={{
                          borderBottom:
                            index < categorySeq.length - 1
                              ? "1px dotted #8D8D8D"
                              : "none",
                        }}
                      >
                        <Typography style={{ textAlign: "left" }}>
                          <span style={selectedStyle(obj.category_id)}>
                            {obj.category_name}
                          </span>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <div>
                          {(() => {
                            if (!obj?.cat_img) return null;
                            const sid = String(obj?.store_id || '').trim();
                            const rawImg = String(obj.cat_img).trim().replace(/^\/+/, '');
                            const baseUrl = (IMG_URL || '').replace(/\/+$/, '');
                            const imgSrc = (rawImg.startsWith('http://') || rawImg.startsWith('https://'))
                              ? rawImg
                              : (sid && !rawImg.startsWith(`${sid}/`))
                              ? `${baseUrl}/${sid}/${rawImg}`
                              : `${baseUrl}/${rawImg}`;
                            return (
                              <img
                                alt="Banner"
                                style={{ minWidth: "100%", borderRadius: "15px" }}
                                src={imgSrc}
                                onError={(e) => { e.target.style.display = 'none'; }}
                              />
                            );
                          })()}

                          {filterPriceItems.length ? (
                            <>
                              {filterPriceItems.some(
                                (e) => e.item_variant.length > 1
                                // && e.modifiers_group[0]?.side_bar
                              ) && (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                  }}
                                >
                                  <Grid
                                    container
                                    style={{
                                      paddingTop: "1rem",
                                      textAlign: "left",
                                      display: "flex",
                                      justifyContent: "center",
                                      color:  textColor,
                                    }}
                                  >
                                    <Grid xs={8}>
                                      <Typography
                                        style={{
                                          display: "flex",
                                          flexDirection: "column",
                                          marginLeft: "0.3rem",
                                        }}
                                      >
                                        Items
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={4}
                                      style={{
                                        display: "flex",

                                        justifyContent: "space-between",
                                      }}
                                    >
                                      {(() => {
                                        const modifiersGroup =
                                          filterPriceItems.find(
                                            (item) =>
                                              item.modifiers_group[0]
                                                ?.item_modifier.length > 1
                                          )?.modifiers_group[0];
                                        const itemWithModifiers =
                                          filterPriceItems.find(
                                            (item) =>
                                              item.modifiers_group[0]
                                                ?.item_modifier.length > 1
                                          );
                                        const variants =
                                          itemWithModifiers?.item_variant || [];
                                        const sortedModifiers = modifiersGroup
                                          ? [
                                              ...modifiersGroup.item_modifier,
                                            ].sort((a, b) => {
                                              const aVariant = variants.find(
                                                (v) =>
                                                  v.modifier_varaint[0]
                                                    ?.mv_id === a.mv_id
                                              );
                                              const bVariant = variants.find(
                                                (v) =>
                                                  v.modifier_varaint[0]
                                                    ?.mv_id === b.mv_id
                                              );
                                              const aPlu = aVariant?.plu || 0;
                                              const bPlu = bVariant?.plu || 0;
                                              return aPlu - bPlu;
                                            })
                                          : [];
                                        return sortedModifiers.map((e) => (
                                          <Typography key={e.modifier_name}>
                                            <span
                                              style={{
                                                fontSize: "18px",
                                                fontWeight: "300",
                                                fontFamily: "Nunito",
                                              }}
                                            >
                                              {e.modifier_name}
                                            </span>
                                          </Typography>
                                        ));
                                      })()}
                                    </Grid>
                                  </Grid>
                                  <Divider
                                    style={{
                                      width: "100%",
                                      background: "gray",
                                      height: "0px",
                                    }}
                                  />
                                </div>
                              )}

                              {/* Map through the items */}
                              {filterPriceItems.map((e, itemIndex) =>
                                e.item_variant.length > 1 ? (
                                  // &&   e.modifiers_group[0]?.side_bar
                                  <div
                                    key={itemIndex}
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Grid
                                      container
                                      style={{
                                        padding: "1rem 0rem",
                                        minHeight: "60px",
                                        textAlign: "left",
                                        paddingTop: "2rem",
                                        display: "flex",
                                        justifyContent: "center",
                                        color:  textColor,
                                      }}
                                    >
                                      <Grid
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                        xs={8}
                                      >
                                        {e?.dietary && (
                                          <img
                                            src={
                                              e?.dietary === "veg"
                                                ? veg
                                                : e?.dietary === "non-veg"
                                                ? nonveg
                                                : ""
                                            }
                                            alt="img"
                                            style={{
                                              width: "15px",
                                              marginTop: "0.3rem",
                                              marginRight: "0.5rem",
                                              height: "15px",
                                              marginLeft: "-1.1rem",
                                            }}
                                          />
                                        )}
                                        <Typography
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            marginLeft: "0.3rem",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "18px",
                                              fontWeight: "400",
                                              textTransform: "capitalize",
                                              fontFamily: "Nunito",
                                            }}
                                          >
                                            {e?.item_name}
                                          </span>
                                          <span
                                            style={{
                                              color: "gray",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {e?.description !== "null"
                                              ? e?.description
                                              : ""}
                                          </span>
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        style={{
                                          display: "flex",
                                          justifyContent: "space-between",
                                          paddingLeft: "1rem",
                                        }}
                                      >
                                        {(() => {
                                          const getMvId = (variant) =>
                                            variant.modifier_varaint?.[0]
                                              ?.mv_id || "";
                                          const sortedVariants = [
                                            ...e.item_variant,
                                          ].sort((a, b) => a.plu - b.plu);
                                          return sortedVariants.map(
                                            (variant, variantIndex) => (
                                              <Typography key={variantIndex}>
                                                <span
                                                  style={{
                                                    fontSize: "18px",
                                                    fontWeight: "300",
                                                    fontFamily: "Nunito",
                                                  }}
                                                >
                                                  {currency} {variant.plu}
                                                </span>
                                              </Typography>
                                            )
                                          );
                                        })()}
                                      </Grid>
                                    </Grid>
                                    <Divider
                                      style={{
                                        width: "95%",
                                        borderBottom: "1px dotted gray",
                                        height: "0px",
                                      }}
                                    />
                                  </div>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Grid
                                      container
                                      style={{
                                        padding: "1rem",
                                        minHeight: "60px",
                                        textAlign: "left",
                                        display: "flex",
                                        justifyContent: "center",
                                        color:  textColor,
                                      }}
                                    >
                                      <Grid
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                        xs={9}
                                      >
                                        {e?.dietary && (
                                          <img
                                            src={
                                              e?.dietary === "veg"
                                                ? veg
                                                : e?.dietary === "non-veg"
                                                ? nonveg
                                                : ""
                                            }
                                            alt="img"
                                            style={{
                                              width: "15px",
                                              height: "15px",
                                              marginTop: "0.3rem",
                                              marginRight: "0.5rem",
                                              marginLeft: "-1.1rem",
                                            }}
                                          />
                                        )}
                                        <Typography
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            marginLeft: "0.3rem",
                                          }}
                                        >
                                          <span
                                            style={{
                                              fontSize: "18px",
                                              fontWeight: "400",
                                              textTransform: "capitalize",
                                              fontFamily: "Nunito",
                                            }}
                                          >
                                            {e?.item_name}
                                          </span>
                                          <span
                                            style={{
                                              color: "gray",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {e?.description !== "null"
                                              ? e?.description
                                              : ""}
                                          </span>
                                        </Typography>
                                      </Grid>
                                      <Grid
                                        item
                                        xs={3}
                                        style={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        {(() => {
                                          const getMvId = (variant) =>
                                            variant.modifier_varaint?.[0]
                                              ?.mv_id || "";
                                          const sortedVariants = [
                                            ...e.item_variant,
                                          ].sort((a, b) => a.plu - b.plu);
                                          return sortedVariants.map(
                                            (variant) => (
                                              <Typography>
                                                <span>{currency} {variant?.plu}</span>
                                              </Typography>
                                            )
                                          );
                                        })()}
                                      </Grid>
                                    </Grid>
                                    <Divider
                                      style={{
                                        width: "95%",
                                        borderBottom: "1px dotted gray",
                                        height: "0px",
                                      }}
                                    />
                                  </div>
                                )
                              )}
                            </>
                          ) : (
                            <Grid>
                              <Typography
                                style={{
                                  color:  textColor,
                                }}
                              >
                                No item found, Try to change filter
                              </Typography>
                              <Typography
                                style={{
                                  color:  textColor,
                                }}
                              >
                                Or Choose another Category
                              </Typography>
                            </Grid>
                          )}
                        </div>
                        {obj?.category_des_1 || obj?.category_des_2 ? (
                          <Typography
                            style={{
                              textAlign: "left",
                              paddingTop: "16px",
                              color:  textColor,
                            }}
                          >
                            <span>
                              <b>{obj?.category_des_1} </b>
                            </span>
                            <br></br>
                            {obj?.category_des_2
                              ?.split("<br/>")
                              .map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                          </Typography>
                        ) : (
                          ""
                        )}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    cartProps: state.cartReducer,
    reducer: state.customerReducer || {},
    sessionReducer: state.sessionReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    set_customer: (obj) => {
      dispatch(set_customer(obj));
    },
    set_last_order: (obj) => {
      dispatch(set_last_order(obj));
    },
    set_filters: (obj) => {
      dispatch(set_filters(obj));
    },
    set_order_type: (obj) => {
      dispatch(set_order_type(obj));
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(MenuItem);
